import { css } from "@emotion/react";

export const styles = {
  base: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    width: 100%;
    margin: auto;
  `,
  sideBySide: css`
    display: grid;
    max-width: 100%;
    justify-content: start;
    margin: 0;
    grid-template-columns: 40% 60%;

    .agent-workflow-right {
      animation: fadeInFromLeft 0.3s ease-in-out;
    }

    .agent-workflow-left {
      animation: fadeInFromRight 0.3s ease-in-out;
    }

    @keyframes fadeInFromLeft {
      0% {
        opacity: 0;
        transform: translateX(-20px);
      }
      100% {
        opacity: 1;
        transform: translateX(0);
      }
    }

    @keyframes fadeInFromRight {
      0% {
        opacity: 0;
        transform: translateX(20px);
      }
      100% {
        opacity: 1;
        transform: translateX(0);
      }
    }
  `,
  left: css`
    background-color: var(--color-background-secondary);
    justify-content: center;
    margin: 0;
    display: flex;
    align-items: center;
    flex: 1;
    width: 100%;
    height: 100vh;
    position: sticky;
    top: 0;
    bottom: 0;
    .kit-Chat {
      max-width: 896px;
      width: 100%;
      margin: auto;
      position: sticky;
      top: 0;
      bottom: 0;
    }
  `
};
